import { Carousel, Image } from 'antd'
import { SFuncModal } from 'shj-components'
import styles from './index.module.less'

const ViewFileDom = (props: { onClose: () => void; fn?: () => void; [key: string]: any }) => {
  const { record } = props
  return (
    <div className={styles.fileView}>
      {Array.isArray(record?.fileList) ? (
        <div style={{ marginBottom: '10px' }}>
          <Carousel autoplay>
            {record?.fileList.map((item, index) => {
              return (
                <Image
                  key={'img_' + index}
                  width={550}
                  height={360}
                  style={{ objectFit: 'cover', display: 'block' }}
                  src={item.path}
                ></Image>
              )
            })}
          </Carousel>
        </div>
      ) : null}
    </div>
  )
}

export function ViewFile(props: any) {
  const { fn, ...otherProps } = props
  let dialog: any = null
  const onClose = () => {
    dialog?.destroy?.()
  }
  dialog = SFuncModal({
    width: 600,
    title: `附件`,
    content: <ViewFileDom onClose={onClose} fn={fn} {...otherProps} />,
    footer: null,
  })

  return dialog
}
